/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import BenchlingConfig from 'BenchlingConfig';
import {AccountType, TFIFile, TFIObject} from 'notebook/tfi/TFIConstants';
import {listToReadable} from 'util/NameUtil';
import {assertNever} from 'util/Types';

function isTFIFile(tfiObject: TFIObject): tfiObject is TFIFile {
  return !tfiObject.isFolder && tfiObject.hasOwnProperty('modifiedAt');
}

function readableAccountType(accountType: AccountType): string {
  switch (accountType) {
    case AccountType.BOX:
      return 'Box';
    case AccountType.DROPBOX:
      return 'Dropbox';
    case AccountType.EGNYTE:
      return 'Egnyte';
    case AccountType.ONEDRIVE:
      return 'OneDrive';
    case AccountType.HOSTED_S3:
      throw new Error(`TFI Error: Unexpected TFI account type`);
    default:
      throw new Error(`TFI Error: ${assertNever(accountType)} is not a valid TFI account type`);
  }
}

function overwriteMessage(accountType: AccountType): string {
  const serviceName = readableAccountType(accountType);
  return `Overwrite Benchling file with ${serviceName} file`;
}

function getAllowedAccountTypes(): Array<AccountType> {
  return _.compact([
    // Keep enterprise TFIs at the top since they're more likely to be important if enabled
    BenchlingConfig.TFI_ENABLE_EGNYTE ? AccountType.EGNYTE : undefined,
    BenchlingConfig.TFI_ENABLE_ONEDRIVE ? AccountType.ONEDRIVE : undefined,

    // "Consumer" TFIs
    BenchlingConfig.TFI_ENABLE_BOX ? AccountType.BOX : undefined,
    BenchlingConfig.TFI_ENABLE_DROPBOX ? AccountType.DROPBOX : undefined,
  ]);
}

// Readable, "or"-joined list of the enabled providers; empty when none are enabled.
function getAllowedAccountsString(): string {
  return listToReadable(
    getAllowedAccountTypes().map((accountType) => readableAccountType(accountType)),
    'or'
  );
}

export default {
  isTFIFile,
  readableAccountType,
  overwriteMessage,
  getAllowedAccountTypes,
  getAllowedAccountsString,
};
